// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Button from "../global/Button";
import Input from "../global/Input";
import ImageUploader from "../global/ImageUploader";
import PhoneNumberInput from "../global/PhoneNumberInput";
type FormInput = {
  organizationName: string;
  telephoneNumber: string;
  vat: number;
  trn: number;
  photo: string;
};

const AddOrganizationForm = () => {
  const {
    control,
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm<FormInput>();

  const navigate = useNavigate();

  const onSubmit = async (formData: FormInput, action: "save" | "addNew") => {


    // Navigate based on the action
    if (action === "save") {
      navigate("/auth/org");
    } else if (action === "addNew") {
      navigate("/auth/add-new-court-1");
    }
  };

  return (
    <form
      onSubmit={handleSubmit((formData) => onSubmit(formData, "save"))}
      className="space-y-4 md:space-y-4 max-w-[814px] px-5 "
    >
      <div className="flex flex-row  items-center justify-center gap-6">
        <div className=" flex text-start flex-col items-basline justify-center gap-5 w-full">
          <div className="w-full">
            <Controller
              name="organizationName"
              rules={{ required: true }}
              control={control}
              render={({ field }) => (
                <Input
                  inputProps={{
                    ...field,
                    type: "text",
                  }}
                  label={"Organization Name"}
                />
              )}
            />
            {errors.courtName && (
              <p className="text-red-500">{"This field is required."}</p>
            )}
          </div>

          <div className="w-full">
            <Controller
              name="telephoneNumber"
              rules={{ required: "Mobile Number is required" }}
              control={control}
              render={({ field }) => (
                <PhoneNumberInput
                  field={field}
                  label="Telephone Number"
                  name="telephoneNumber"
                  value={field.value}
                  handleChange={(value) => field.onChange(value)}
                />
              )}
            />
            {errors.telephoneNumber && (
              <p className="text-red-500">{errors.mobileNumber.message}</p>
            )}
          </div>
          <div className="w-full">
            <Controller
              name="vat"
              rules={{ required: true }}
              control={control}
              render={({ field }) => (
                <Input
                  inputProps={{
                    ...field,
                     type: "number",
onWheel:(e)=>{
                          e.preventDefault()
                          //@ts-ignore
                          e.target.blur()
                        },
                  }}
                  label={"VAT Registration"}
                />
              )}
            />
            {errors.courtName && (
              <p className="text-red-500">{"This field is required."}</p>
            )}
          </div>
          <div className="w-full">
            <Controller
              name="trn"
              rules={{ required: true }}
              control={control}
              render={({ field }) => (
                <Input
                  inputProps={{
                    ...field,
                     type: "number",
onWheel:(e)=>{
                          e.preventDefault()
                          //@ts-ignore
                          e.target.blur()
                        },
                  }}
                  label={"TRN Number"}
                />
              )}
            />
            {errors.courtName && (
              <p className="text-red-500">{"This field is required."}</p>
            )}
          </div>
        </div>
        <div className="w-full">
          <ImageUploader
            height="h-[320px]"
            register={register}
            setValue={setValue}
          />
        </div>
      </div>

      <div className="flex flex-row justify-center items-center gap-10 ">
        <Button
          customeStyle="bg-primary text-white w-full rounded-full text-base py-2.5 border-primary border-2 mt-1"
          text="Get Started"
          width="max-w-[400px] w-full"
          type="button"
          onClick={handleSubmit((formData) => onSubmit(formData, "addNew"))}
        />
      </div>
    </form>
  );
};

export default AddOrganizationForm;
